import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import './index.scss';
import { BhHeaderV2Lang } from 'eco-design/section-layout/ef-header-v2/BhHeaderV2Lang';
import getLocal from 'eco-design-reliance/getLocal';
import { getCardAnimation } from '../common';

interface Props {
    prefixCls: string;
    activeItemB: any;
    active?: boolean;
    isH5?: boolean;
}

const TypeContent: React.FC<Props> = ({ prefixCls, activeItemB, active, isH5 }) => {
    const { locale = '' } = getLocal();
    const t = BhHeaderV2Lang[locale] || BhHeaderV2Lang['en'];
    const lItemsSubs = activeItemB.subs || []; // 二级内容
    let rItemsSubs: any[] = [];
    try {
        const extJson = activeItemB?.extJson;
        if (extJson && extJson.trim() !== '') {
            rItemsSubs = JSON.parse(extJson);
        } else {
            rItemsSubs = [];
        }
    } catch (e) {
        rItemsSubs = [];
    }

    return (
        <>
            <div className={`${prefixCls}-card-type-a__title ${isH5 ? 'isH5' : ''} ${active ? 'active' : ''}`}>{activeItemB.subtitle}</div>
            <div className={`${prefixCls}-card-type-a__content  ${isH5 ? 'isH5' : ''} ${active ? 'active' : ''}`}>
                <div className={`${prefixCls}-card-type-a__content-left`}>
                    {lItemsSubs.map((i: any, idx: number) => {
                        return (
                            <div
                                className={`${prefixCls}-card-type-a__content-left-item`}
                                style={{
                                    animation: getCardAnimation(idx),
                                }}
                                key={i.id || idx}
                            >
                                <EcoImg className={`${prefixCls}-card-type-a__content-left-item-img`} pc={i.pictureUrl} />
                                <div className={`${prefixCls}-card-type-a__content-left-item-label`}>{t.label[i.label] || i.label}</div>
                                <div className={`${prefixCls}-card-type-a__content-left-item-title`}>{i.heading}</div>
                                <div className={`${prefixCls}-card-type-a__content-left-item-desc`}>{i.subtitle}</div>
                                {(i.buyUrl || i.learnMoreUrl) && (
                                    <div className={`${prefixCls}-card-type-a__content-left-item-btns`}>
                                        {i.learnMoreUrl && (
                                            <EcoLink className={`${prefixCls}-card-type-a__content-left-item-more`} href={i.learnMoreUrl}>
                                                {t.more}
                                            </EcoLink>
                                        )}
                                        {i.buyUrl && (
                                            <EcoLink className={`${prefixCls}-card-type-a__content-left-item-buy`} href={i.buyUrl} target="_blank">
                                                {t.buy}
                                            </EcoLink>
                                        )}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                <ul className={`${prefixCls}-card-type-a__content-right`}>
                    {rItemsSubs.map((i: any, idx: number) => (
                        <li
                            className={`${prefixCls}-card-type-a__content-right-item`}
                            style={{
                                animation: getCardAnimation(idx, lItemsSubs.length),
                            }}
                            key={i.updateTime || idx}
                        >
                            <EcoLink className={`${prefixCls}-card-type-a__content-right-item-link`} href={i.url} target="_blank">
                                <EcoImg className={`${prefixCls}-card-type-a__content-right-item-icon`} pc={i.pictureUrl} />
                                {i.name}
                            </EcoLink>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};
export default TypeContent;
